module.exports = __webpack_public_path__ + "img/pmb1.c61c39f0.jpg";